(function (angular) {
    "use strict";

    function drv() {
        return {
            restrict: "E",
            transclude: true,
            scope: {
                model: "=",
                checkboxText: '@?',
                titleGenerator: '&?',
                
                additionalText: '@?',
                maxWords: '=?'
            },
            templateUrl: "views/templates/customize-md-checkbox.html",
            controllerAs: "customizeMdCheckboxCtrl",
            controller: ["$scope", "$window", "Util", "$transclude", ctrl],
        };
    }

    function ctrl($scope, $window, Util, $transclude) {
        var customizeMdCheckboxCtrl = this;

        _init();

        function _init() {
            $scope.showFullLegalText = false;
            $scope.shouldUseShortAdditionalText = false;
            $scope.hasTranscludedContent = false;

            // Check if there's transcluded content
            $transclude(function(clone) {
                $scope.hasTranscludedContent = clone.length > 0 && clone.text().trim() !== '';
            });

            if ($scope.additionalText && $scope.maxWords) {
                $scope.shortAdditionalText = truncateTextByWords($scope.additionalText, $scope.maxWords);
                $scope.shouldUseShortAdditionalText = $scope.additionalText !== $scope.shortAdditionalText;
            }
        }

        function truncateTextByWords(text, maxWords) {
            if (!text || !maxWords) {
                return text;
            }

            var words = text.trim().split(/\s+/);
            if (words.length <= maxWords) {
                return text;
            }

            return words.slice(0, maxWords).join(' ');
        }

    }

    angular.module("mobilezuz").directive("customizeMdCheckbox", drv);
})(angular);

